import Paper from "@mui/material/Paper";
import React, {CSSProperties, useCallback, useEffect, useMemo, useState} from "react";
import {Day} from "./core/Day";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {IBoard} from "./core/IBoard";
import {SxProps} from "@mui/material";

interface IProps extends IBoard{

    selectedYear: number;
    onClick?: () => void;
    options?: {
        sx?: SxProps;
    }

}

export default function Board(props: IProps){

    const { id, title, data, availableOptions, onClick, selectedYear, options } = props;


    const getDateFromDayNumber = (dayOfYear: number, year: number) => {
        // Start of the year
        const startOfYear = new Date(year, 0, 1); // January 1st
        // Add the day number as an offset (subtract 1 because January 1 is day 1)
        const targetDate = new Date(startOfYear.setDate(dayOfYear));

        // Extract the month and day
        const month = targetDate.getMonth() + 1; // Months are 0-based, so add 1
        const day = targetDate.getDate();

        return { day, month };
    }

    const getAbsoluteDayNumber = (month: number, day: number, year: number): number => {
        // Create a date object for the given year
        const startOfYear = new Date(year, 0, 1); // January 1st
        const targetDate = new Date(year, month - 1, day); // Adjust for zero-based months

        // Calculate the difference in milliseconds
        const diffInMs = targetDate.getTime() - startOfYear.getTime();

        // Convert milliseconds to days
        return Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1;
    }

    const [components, setComponents] = useState<{ [x: number]: any[] }>({1:[],2:[],3:[],4:[],5:[],6:[],7:[],8:[],9:[],10:[],11:[],12:[]});

    useEffect(() => {
        const thisYearsData = data.find((boardData) => boardData.year === selectedYear) ?? {
            year: selectedYear,
            days: new Map<number, Day | null>()
        };

        for(let dayNumber = 1; dayNumber <= getAbsoluteDayNumber(12,31,selectedYear); dayNumber++){
            if(!thisYearsData.days.has(dayNumber))
            {
                thisYearsData.days.set(dayNumber, null);
            }
        }

        const internalDayComponents: any = {};

        for(let dayNumber = 1; dayNumber <= getAbsoluteDayNumber(12,31,selectedYear); dayNumber++){
            const localDay = thisYearsData.days.get(dayNumber);

            const {day, month} = getDateFromDayNumber(dayNumber, selectedYear)

            if(day === 1){
                internalDayComponents[month] = [];
            }

            const colors: string[] = [];

            localDay?.selectedOptions.forEach((selectedOption) => {
                colors.push(selectedOption.color);
            })

            let linearGradient;
            if(colors.length > 1) {
                linearGradient = `linear-gradient(45deg, ${colors.join(', ')})`;
            }
            else if(colors.length === 1){
                linearGradient = colors[0];
            }
            else{
                linearGradient = '#d5d5d5';
            }

            // if(day < 20)
            internalDayComponents[month].push (
                <Box key={`board-${id}-${selectedYear}-calendar-${dayNumber}`} sx={{
                    borderRadius: '2px',
                    width: '7px',
                    height: '7px',
                    margin: 0,
                    padding: 0,
                    fontSize: '0px',
                    background: linearGradient,
                    marginBottom: '1px',
                    marginRight: '4px',
                    boxSizing: 'border-box'
                }}>

                </Box>
            )

        }

        setComponents(internalDayComponents);

    }, [selectedYear, data]);

    const sxStyle = (components: any[]): CSSProperties => {
        return {
            // height: components.length * 8,
            display: 'flex',
            // justifyContent: 'space-between',
            flexDirection: 'column'
        }
    }

    const looper: number[] = [1,2,3,4,5,6,7,8,9,10,11,12];

    const allComponents = useMemo(() => {

        return looper.map((monthNumber) => {
            return (
                <Box key={`board-${id}-generated-month-${monthNumber}`} className={`month-${monthNumber}`} sx={sxStyle(components[monthNumber])}>
                    {
                        components[monthNumber]
                    }
                </Box>
            )
        });

    }, [components]);

    return (
        <Paper
            sx={{
                height: '300px',
                p: 1,
                ...options?.sx
            }}
            onClick={onClick ?? undefined}
        >
            <Typography sx={{color: "#606060", mb: 0.5}}>{title}</Typography>

            <Box sx={{display: 'flex'}}>
                <Box sx={{display: 'flex'}}>

                    {
                        allComponents
                    }
                </Box>
                <Box sx={{ marginX: 'auto' }}>
                    {
                        availableOptions.map((availableOption) => {

                            return (
                                <Box
                                    key={`board-${id}-available-option-${availableOption.name}`}
                                    sx={{
                                        width: '16px',
                                        height: '16px',
                                        borderRadius: '6px',
                                        background: availableOption.color,
                                        mb: 1
                                    }}
                                >
                                </Box>
                            );

                        })
                    }
                </Box>
            </Box>

        </Paper>
    )

}